import Actions                           from 'Redux/Actions';
import { OrganisationInvoiceRepository } from 'Domain/Repositories';
import { ofType }                        from 'redux-observable';
import { from, EMPTY }                   from 'rxjs';
import { mergeMap }                      from 'rxjs/operators';
import { TEpic }                         from 'Redux/Config';
import { message }                       from 'antd';

export const sendOrganisationInvoicePdfEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.sendOrganisationInvoicePdfRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        OrganisationInvoiceRepository.sendOrganisationInvoicePdf(id)
          .then(() => {
            message.success('Rechnung wurden erfolgreich erneut versendet.');

            return Actions.sendOrganisationInvoicePdfSuccess();
          })
          .catch((error: any) => Actions.sendOrganisationInvoicePdfFailure({ error })),
      );
    }),
  );
};
